class JsUtils {

    /**
     * returnerar false om elementId inte hittas, annars true;
     * använd default är smooth scroll, skicka in false för att få auto/instant scroll.
     * @param elementId
     * @param smoothScroll
     * @returns
     */
    public static ScrollPageToElement(elementId:string, smoothScroll:boolean = true):boolean {
        const element = document.getElementById(elementId);
                
        element?.scrollIntoView({
            behavior: smoothScroll ? 'smooth' : 'auto'
           /* behavior: 'smooth'*/
        });
                
        return element != null
    }
    /**
   * returnerar false om elementet body inte hittas (kan typ inte hända), annars true;
   * använd default är smooth scroll, skicka in false för att få auto/instant scroll.
   * denna scrollar <body> into view.
   * @param smoothScroll
   * @returns 
   */
    public static ScrollPageToFirstInvalidElement(smoothScroll: boolean = true): boolean {
        const validationMessageElement = document.querySelector(".validation-message") as any;
        const firstInvalidNode = validationMessageElement.parentNode.getElementsByTagName("input")[0]
            ?? validationMessageElement.parentNode.getElementsByTagName("textarea")[0];

        if (validationMessageElement) {
            firstInvalidNode.focus({ preventScroll: true });
            validationMessageElement.parentNode.scrollIntoView({ behavior: smoothScroll ? 'smooth' : 'auto', block: 'center' });
            return true;
        }

        return false;
    }

    /**
  * För andra sidor som behöver kunna scrolla upp till toppen av sidan
  * denna scrollar till starten av innehållet på sidan till länken hoppa till innehåll.
  * @param smoothScroll 
  * @returns
  */
    public static ScrollContentToTop(smoothScroll: boolean = true): boolean {   
        const element = document.querySelector(".scroll-to-top") as any;
       
        if (element) {
            element.focus({ preventScroll: true })
            element.scrollIntoView({ behavior: smoothScroll ? 'smooth' : 'auto', block: 'start' });          
            return true;
        }

        return false;
    }

    /**
   * För skadeflödet!
   * Setter timer på focus på nästa sida så att den hinner rederas  
   * 
   * @param smoothScroll
   * @returns
   */
    public static ScrollPageToTop(smoothScroll: boolean = true): boolean {
        const myTimeout = setTimeout(JsUtils.ScrollPageToFirstInput, 100, smoothScroll)
        return true;
    }

     /**
    * För skadeflödet som har steps-navigation-top
    * returnerar false om step-navigation-top inte hittas, annars true; 
    * använd default är smooth scroll, skicka in false för att få auto/instant scroll.
    * denna scrollar <body> into view.
    * @param smoothScroll 
    * @returns
    */
    private static ScrollPageToFirstInput(smoothScroll: boolean = true) {
        const top = document.querySelector(".scroll-to-top") as any;
        const elements = document.querySelector(".steps-output") as any;
        const element = elements.querySelector(".is-active") as any;  
        let nodeInput = element.getElementsByTagName("input")[0];
        const nodeTextArea = element.getElementsByTagName("textarea")[0];
        const nodeSelect = element.getElementsByTagName("select")[0];

        if (nodeInput.hidden) {
            if (nodeTextArea) {
                nodeInput = nodeTextArea;
            }
            if (nodeSelect) {
                nodeInput = nodeSelect;
            }
        }
        
        if (nodeInput) {
            nodeInput.focus({ preventScroll: true });
            top.scrollIntoView({ behavior: smoothScroll ? 'smooth' : 'auto', block: 'start' });
        }
        else if (top) {
            top.focus({ preventScroll: true });
            top.scrollIntoView({ behavior: smoothScroll ? 'smooth' : 'auto', block: 'start' });          
        }
        else {
            window.scrollTo(0, 0);
        }
    }

    /** iphone hanterar inte behaviours som "smooth" på ett bra sätt,
     * funkar kanske på nyare devices/IOS men dåligt på äldre (2024-02..)*/
    public static ScrollWindowToTop() {
        window.scrollTo(0, 0);        
    }

    /** iphone hanterar inte behaviours som "smooth" på ett bra sätt,
     * funkar kanske på nyare devices/IOS men dåligt på äldre (2024-02..)*/
    public static ScrollToTopOfForm() {
        const elements = document.querySelector(".optimizelyForms") as any;
        let nodeForm = elements.getElementsByTagName("form")[0];
        nodeForm.focus({ preventScroll: true });
        elements.scrollIntoView({ behavior: 'auto', block: 'start' });
    }

    /** Efter att man skickat in epi formulär behöver man scrolla till toppen av sidan för att se
     * meddelande om att inskickningen gått bra. Scrollen behöver deayas för att inte hända före
     * koden som hanterar formuläret.
     */
    public static ScrollEpiFormToTop() {
        const myTimeout = setTimeout(JsUtils.ScrollToTopOfForm, 1000)
    }


    public static ScrollElementLeft(containerElementId: string, scrollElementId: string,  amountOfElementsToScroll: number) {
        const containerElement = document.getElementById(containerElementId);
        const scrollElement = document.getElementById(scrollElementId);

        const computedStyle = window.getComputedStyle(scrollElement!);
        const scrollElementWidth = parseFloat(computedStyle.width) + parseFloat(computedStyle.marginLeft) + parseFloat(computedStyle.marginRight);

        const currentScrollAmount = containerElement?.scrollLeft ?? 0;
        const scrollTo = currentScrollAmount - (scrollElementWidth * amountOfElementsToScroll);

        containerElement?.scrollTo({
            top: 0,
            left: scrollTo,
            behavior: 'smooth',
        });
    }

    public static ScrollElementRight(containerElementId: string, scrollElementId: string, amountOfElementsToScroll: number) {
        const containerElement = document.getElementById(containerElementId);
        const scrollElement = document.getElementById(scrollElementId);

        const computedStyle = window.getComputedStyle(scrollElement!);
        const scrollElementWidth = parseFloat(computedStyle.width) + parseFloat(computedStyle.marginLeft) + parseFloat(computedStyle.marginRight);

        const currentScrollAmount = containerElement?.scrollLeft ?? 0;
        const scrollTo = currentScrollAmount + (scrollElementWidth * amountOfElementsToScroll);

        containerElement?.scrollTo({
            top: 0,
            left: scrollTo,
            behavior: 'smooth',
        });
    }

    public static IsElementScrollable(elementId: string) {
        const element = document.getElementById(elementId);

        const currentScrollLeft = element?.scrollLeft ?? 0;
        const maxScrollLeft = (element?.scrollWidth ?? 0) - (element?.clientWidth ?? 0);

        const scrollFaultMargin = 10;
        const isScrollableLeft = currentScrollLeft > (0 + scrollFaultMargin);
        const isScrollableRight = currentScrollLeft < (maxScrollLeft - scrollFaultMargin);

        return { isScrollableLeft, isScrollableRight };
    }
}


export const {
    ScrollPageToElement,
    ScrollPageToFirstInvalidElement,
    ScrollContentToTop,
    ScrollPageToTop,
    ScrollEpiFormToTop,
    ScrollWindowToTop,
    ScrollElementLeft,
    ScrollElementRight,
    IsElementScrollable
} = JsUtils;